export const featureFlagKeys = {
  emailFeeds: 'email-feeds',
  brandEmails: 'brand-emails',
  intercom: 'intercom',
  captcha: 'turnstile',
  annualPlans: 'annual-plans',
  search: 'search',
  userback: 'user-feedback',
  darkMode: 'dark-mode',
  editor: 'editor-access',
  audioplayer: 'audioplayer',
  teams: 'teams',
  welcomeScreen: 'welcome-screen',
  brainBreak: 'brain-break',
  fca: 'fca',
  creativeAnalysis: 'creative-analysis',
  viewFCAAnalysis: 'view-fca-analysis',
  funnelInspiration: 'funnel-inspiration',
  fcaHistory: 'fca-history',
  agenticSearch: 'agentic-search',
  maintenanceMode: 'maintenance-mode',
  googlePay: 'google-pay',
  applePay: 'apple-pay',
  payPalExpressCheckout: 'paypal-express-checkout',
  extraPaymentMethods: 'extra-payment-methods',
  requestTemplates: 'request-template',
  useChargebeeSelfServicePortal: 'use-chargebee-self-service-portal',
  redirectLogin: 'redirect-login',
}
